import { createSelector } from '@reduxjs/toolkit';

import { IState } from 'shared/store';

export const getDecorationsInHouse = createSelector(
  (state: IState) => state.offerData.housingDecorations,
  housingDecorations => housingDecorations || [],
);
